module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('span', [(_vm.apiResponse.success === true) ? _c('div', {
    staticClass: "notification is-success"
  }, [_vm._v("\n    The configuration was sent. Your device will reboot. You can close this page.\n  ")]) : _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v("\n    There was an error while sending the configuration: " + _vm._s(_vm.apiResponse.error) + "\n    "), _c('br'), _vm._v("\n    Please retry or report if it looks like a bug.\n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b78b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Sending.vue
// module id = 55
// module chunks = 0